import { Options, Splide } from '@splidejs/splide'

import { isTabletUp } from '../../../../Resources/Private/TypeScript/Utility/Breakpoint'
import { getElementChildren, getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'

class TestimonialSlider {
  private sliderOptions: Options = {
    arrows: false,
    breakpoints: {
      1024: {
        perPage: 2
      },
      768: {
        focus: 'center',
        gap: '1rem',
        perPage: 1.1
      },
    },
    gap: '1.25rem',
    omitEnd: true,
    perPage: 3,
    type: 'slide',
  }
  private sliders: NodeListOf<HTMLElement>

  constructor() {
    this.sliders = getElements('testimonial-slider')
  }

  public init(): void {
    this.sliders.forEach((slider): void => {
      const maxItems: number = +slider.getAttribute('data-items')
      const options: Options = {
        ...this.sliderOptions,
        perPage: maxItems > 0 ? maxItems : this.sliderOptions.perPage
      }
      const cards = getElementChildren(slider, 'testimonial-card')
      cards.forEach((card: HTMLElement): void => {
        card.dataset.id = `${Math.floor(Math.random() * 5)}`
      })

      const splide = new Splide(slider, options)

      splide.on('overflow', (isOverflow: boolean): void => {
        splide.options = {
          arrows: isOverflow && isTabletUp(),
          drag: isOverflow
        }
      })

      splide.mount()
    })
  }
}

const testimonialSlider = new TestimonialSlider()
testimonialSlider.init()
